import { render, staticRenderFns } from "./ceping-edit.vue?vue&type=template&id=83b8e788&scoped=true&"
import script from "./ceping-edit.vue?vue&type=script&lang=ts&"
export * from "./ceping-edit.vue?vue&type=script&lang=ts&"
import style0 from "./ceping-edit.vue?vue&type=style&index=0&id=83b8e788&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b8e788",
  null
  
)

export default component.exports